const ProjectExchangeList = () => import('Views/projectExchange/projectExchange-list-new-ui');
const ProjectExchangeAdultList = () => import('Views/projectExchange/projectExchangeAdult-list-new-ui');
const ProjectExchangeEdit = () => import('Views/projectExchange/projectExchange-edit-new-ui');
const ProjectExchangeDetail = () => import('Views/projectExchange/projectExchange-detail-new-ui');

export default[
  { path: '/projectExchange-list', component: ProjectExchangeList },
  { path: '/projectExchangeAdult-list', component: ProjectExchangeAdultList },
  { path: '/projectExchange-list', component: ProjectExchangeList },
  { path: '/projectExchange-edit/:id', component: ProjectExchangeEdit },
  { path: '/projectExchange-detail/:id', component: ProjectExchangeDetail },
];



// WEBPACK FOOTER //
// ./src/router/projectExchange.js